import React from 'react';
import { Banner } from '@pwc/appkit-react/lib/Banner';


const TaxExpenseDraftBanner = () => {
  const warningMessage = (
    <>
      <strong>DRAFT ONLY</strong>{` - Entries are pending calculation, provision results are not final.`}
    </>
  );

  return (
    <div className="tax-expense-draft-banner">
      <Banner status="warning" content={warningMessage} />
    </div>
  );
};


export default TaxExpenseDraftBanner;
